export default function GreenDot() {
    return (
        <>
            <div className="absolute right-[2px] bottom-[1px] p-1 bg-green-400 rounded-full animate-ping"></div>
            <div className="absolute right-0 p-1 bg-green-400 border border-white rounded-full bottom-0"></div>

        </>
    )
}